import React, { useEffect, useState } from 'react';
import Slider from "react-slick";
import { getTopper } from '../Service/Api';
import { Link } from 'react-router-dom';
import LazyLoad from 'react-lazyload';
const ToppersXII = () => {
  const [classXIIData, setClassXIIData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const topperData = await getTopper();
      const currentYear = new Date().getFullYear();
      const yearString = `${currentYear - 1}-${currentYear}`;
      
      const classX = topperData.filter((item) => item.class === 'XII' && item.sessionYear === yearString);
      setClassXIIData(classX); 
      
      console.log("Filtered class X data for year", yearString, classX);
    };
    fetchData();
  }, []);
  const emptyArray = [
    { name: "Student Name", division: "%",stream: 'Stream' },
    { name: "Student Name", division: "%",stream: 'Stream' },
    { name: "Student Name", division: "%",stream: 'Stream' },
    { name: "Student Name", division: "%",stream: 'Stream' }
  ];
  var settings = {
    autoplay: true,
    infinite: false,
    autoplaySpeed: 2000,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
   arrows:false,
    responsive: [
        {
          breakpoint: 1300,
          settings: {
            slidesToShow: 1, 
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2, 
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1, 
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1, 
          }
        }
      ]
  };
  return (
     <>
     <div className="row">
     {classXIIData.length > 0 ? (
        <Slider {...settings}> 
          {classXIIData.map((item1, index) => (
               <div key={index}>
                 <div className="acheiver-blk">
                      <p className="board">12 <sup>th</sup>  <Link to="/TopperXII">  <i className="bi bi-arrow-right-circle"></i>  </Link></p>
                     <div className="acheiver-image"> 
                         <LazyLoad><img src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item1?.attachments}`} alt="St. Francis School, Ranchi"/></LazyLoad>
                     </div>
                     <div className="content">
                        <LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STFSR/public/Images/acheivements.gif" className="balon-gif" alt="St. Francis School, Ranchi" /> </LazyLoad>
                         <h3>{item1?.name}  </h3>
                         <p>{item1?.stream}</p>
                         <div className="percentage">
                         {item1?.division}
                     </div>
                    
                     </div> 
                     
                 </div>
            </div>
           ))}
           </Slider>
           ) : (
             <Slider {...settings}> 
               {emptyArray.map((data, index) => (
                 <div className="item" key={index}>
                       <div className="acheiver-blk">
                      <p className="board">12 <sup>th</sup> <Link to="/TopperXII">  <i className="bi bi-arrow-right-circle"></i>  </Link></p>
                     <div className="acheiver-image"> 
                         <LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STFSR/public/Images/defaultImage.jpg" alt="St. Francis School, Ranchi"/></LazyLoad>
                     </div>
                     <div className="content">
                        <LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STFSR/public/Images/acheivements.gif" className="balon-gif" alt="St. Francis School, Ranchi" /> </LazyLoad>
                         <h3>{data.name}  </h3>
                         <p>{data.stream}</p>
                         <div className="percentage">
                         {data.division}
                     </div>
                    
                     </div> 
                     
                 </div> 
                    </div>
                    ))}
                    </Slider>
                  )}
                </div>
     </>
  )
}

export default ToppersXII
